"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Catalogues = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _contexts = require("../../contexts");
var _useTranslations = require("../../hooks/useTranslations");
var _jsxRuntime = require("react/jsx-runtime");
const Catalogues = ()=>{
    const { translations } = (0, _useTranslations.useTranslations)();
    const { data, loading } = (0, _contexts.useCataloguesLandingPageContext)();
    if (loading || !data) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.CategoryBoxSkeleton, {
                    showDescription: true,
                    animation: loading ? 'pulse' : false,
                    size: _presentationComponents.CategoryBoxSize.LARGE
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.CategoryBoxSkeleton, {
                    showDescription: true,
                    animation: loading ? 'pulse' : false,
                    size: _presentationComponents.CategoryBoxSize.LARGE
                })
            ]
        });
    }
    const { currentCatalogue, nextCatalogue } = data;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            currentCatalogue ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.CategoryBox, {
                buttonText: translations.view,
                description: currentCatalogue.validity,
                imageUrl: currentCatalogue.imageUrl,
                relativeUrl: currentCatalogue.link,
                title: currentCatalogue.title,
                size: _presentationComponents.CategoryBoxSize.LARGE
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.CategoryBoxSkeleton, {
                showDescription: true,
                animation: false,
                size: _presentationComponents.CategoryBoxSize.LARGE
            }),
            nextCatalogue ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.CategoryBox, {
                buttonText: translations.view,
                description: nextCatalogue.validity,
                imageUrl: nextCatalogue.imageUrl,
                relativeUrl: nextCatalogue.link,
                title: nextCatalogue.title,
                size: _presentationComponents.CategoryBoxSize.LARGE
            }) : null
        ]
    });
};
exports.Catalogues = Catalogues;
